export default "__VITE_ASSET__N15woCIN__"